/* eslint-disable no-magic-numbers */
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ breakpoints, tokens }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: tokens.colors.bg.light.secondary,
  },

  rootMobile: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: tokens.colors.bg.light.primary,
  },

  header: {
    backgroundImage: 'url("/bg/header-bg-pattern.svg")',
    backgroundPosition: 'center',
    backgroundSize: 'auto 100%, contain',
    backgroundRepeat: 'repeat-x',
    '& > div': {
      paddingLeft: tokens.spacing['16'],
    },
  },

  headerWithoutBackground: {
    backgroundColor: tokens.colors.bg.greyscale.secondary,
    borderBottom: `1px solid ${tokens.colors.stroke.primary}`,
  },

  logoContainer: {
    display: 'flex',
    padding: `${tokens.spacing['12']}px 0`,
    [breakpoints.up('md')]: {
      padding: `${tokens.spacing['4']}px 0`,
    },
  },
  logo: {
    maxWidth: 115,
    [breakpoints.up('md')]: {
      maxWidth: 200,
    },
  },
  container: {
    flexGrow: 1,
    padding: 0,
    [breakpoints.up('md')]: {
      paddingTop: tokens.spacing['40'],
    },
  },
}));
